export const defaultTranslations = {
  overage_charge: 'Overage charge',
  resources_renew_every_billing_period:
    'The resources will renew every billing period.',
  remaining_resources_will_roll_over_to_next_billing_period:
    'Remaining resources will roll over to the next billing period',
  overages: 'Overages',
  usage: 'Usage',
  prepaid: 'Prepaid',
};
